import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideoOn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconVideoOn"><Path fillRule="evenodd" clipRule="evenodd" d="M2 6.75C2 5.23122 3.23122 4 4.75 4H14.25C15.7688 4 17 5.23122 17 6.75V7.48155L19.4066 6.15789C20.5729 5.51643 22 6.36022 22 7.69127V16.3087C22 17.6398 20.5729 18.4836 19.4066 17.8421L17 16.5185V17.25C17 18.7688 15.7688 20 14.25 20H4.75C3.23122 20 2 18.7688 2 17.25V6.75ZM9.5 15C11.1569 15 12.5 13.6569 12.5 12C12.5 10.3431 11.1569 9 9.5 9C7.84315 9 6.5 10.3431 6.5 12C6.5 13.6569 7.84315 15 9.5 15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVideoOn;
